import { translate } from "hooks";
import type { AnyFolder, Node } from "interfaces/schemas";
import * as identify from "utils/treeUtils";

export const generateFolderName = (
  copiedNodeFolderName: string,
  siblings: Node[] = [],
  isNewLayer: boolean = false,
): string => {
  const nodeFolderName = isNewLayer
    ? translate("PROJECT_NEW_NODE")
    : copiedNodeFolderName;

  if (typeof nodeFolderName !== "string") {
    throw new Error("Failed to generate new folder name");
  }

  const regExpNodeNumber = /\((\d+)\)$/;
  const arrOfSameFolderNames: string[] = [];
  if (siblings && siblings.length) {
    siblings.forEach((siblingNode) => {
      if (!identify.isAnyFolder(siblingNode)) {
        return;
      }
      const { folderName } = siblingNode as AnyFolder;
      if (folderName === nodeFolderName) {
        arrOfSameFolderNames.push(folderName);
      }
    });
  }

  // Case: New layer-node
  if (!siblings || !siblings.length) {
    return nodeFolderName;
  }

  // Case: New node in a layer or there's not nodes with the same folderName
  if (!arrOfSameFolderNames.length) {
    return nodeFolderName;
  }

  const arrOfFolderNameNumbers: number[] = [];
  siblings.forEach((siblingNode: Node) => {
    if (identify.isAnyFolder(siblingNode)) {
      if (!identify.isAnyFolder(siblingNode)) {
        return;
      }
      const { folderName } = siblingNode as AnyFolder;
      const matchedFolderNameNumber = folderName.match(regExpNodeNumber)?.[1];
      if (matchedFolderNameNumber) {
        arrOfFolderNameNumbers.push(Number(matchedFolderNameNumber));
      }
    }
  });

  // Case: Only one node with same folderNames "folderName (1)"
  if (
    !regExpNodeNumber.test(nodeFolderName) &&
    !arrOfFolderNameNumbers.length
  ) {
    return `${nodeFolderName} (1)`;
  }

  const changedNumberFolderName = nodeFolderName
    .replace(regExpNodeNumber, "")
    .trim();

  // Case: Node(s) with same folderNames and with number. "folderName (n+1)"
  return `${changedNumberFolderName} (${Math.max(...arrOfFolderNameNumbers) + 1})`;
};
